export default "__VITE_ASSET__BWIb9ufK__"